import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { isEmpty } from 'lodash';
import { ADDRESS_CATEGORIES } from '../constants/addressCategories';
import { getAddressLabel } from '../services/AddressService';

const { Types, Creators } = createActions({
  setText: ['text'],
  selectAddress: ['selection'],
  getDepartures: ['shouldRequest', 'stopCode', 'options'],
  getMoreDepartures: ['stopCode', 'options'],
  appendDepartures: ['movements'],
  updateDepartures: ['movements', 'messages', 'errors'],
  updateStaticStopsInfo: ['staticStopsInfo'],
  updateFilteredRoutesNames: ['filteredRoutesNames'],
  storeFilteredRoutesNames: ['filteredRoutesNames', 'stopCode'],
  getFilteredRoutesNames: ['stopCode'],
  updateDisplaySurveyButton: ['display'],
});

export const INITIAL_STATE = Immutable({
  text: null,
  mapEnabled: false,
  selection: null,
  movements: null,
  staticStopsInfo: null,
  messages: null,
  noMoreMovements: true,
  isRequesting: false,
  isRequestingMore: false,
  errors: null,
  filteredRoutesNames: null,
  displaySurveyButton: true,
});

const setText = (state, { text }) => state.merge({ text });

const selectAddress = (state, { selection }) => {
  const selectedAddress = getAddressLabel(selection) ?? '';
  return state.merge({
    selection,
    text: selectedAddress,
    mapEnabled: !!selection && selection.category !== ADDRESS_CATEGORIES.BUSSTOP,
  });
};

const getDepartures = (state, { shouldRequest }) => {
  if (shouldRequest) {
    return state.merge({
      isRequesting: true,
    });
  }

  return state.merge({
    isRequesting: false,
    isRequestingMore: false,
    noMoreMovements: false,
    staticStopsInfo: null,
    movements: null,
    messages: null,
    errors: null,
  });
};

const getMoreDepartures = state => state.merge({ isRequestingMore: true });

const updateDepartures = (state, { movements, messages, errors }) => state.merge({
  isRequesting: false, movements, messages, errors,
});

const appendDepartures = (state, { movements }) => state.merge({
  isRequestingMore: false,
  noMoreMovements: isEmpty(movements),
  movements: state.movements.concat(movements),
});

const updateStaticStopsInfo = (state, { staticStopsInfo }) => state.merge({ staticStopsInfo });

const updateFilteredRoutesNames = (state, { filteredRoutesNames }) => state.merge({
  filteredRoutesNames,
});

const updateDisplaySurveyButton = (state, { display }) => state.merge({
  displaySurveyButton: display,
});

export const LiveDepartureTypes = Types;
export default Creators;

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_TEXT]: setText,
  [Types.SELECT_ADDRESS]: selectAddress,
  [Types.GET_DEPARTURES]: getDepartures,
  [Types.GET_MORE_DEPARTURES]: getMoreDepartures,
  [Types.APPEND_DEPARTURES]: appendDepartures,
  [Types.UPDATE_DEPARTURES]: updateDepartures,
  [Types.UPDATE_STATIC_STOPS_INFO]: updateStaticStopsInfo,
  [Types.UPDATE_FILTERED_ROUTES_NAMES]: updateFilteredRoutesNames,
  [Types.UPDATE_DISPLAY_SURVEY_BUTTON]: updateDisplaySurveyButton,
});
